// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-section, .body-section {
   margin: 12px 0;
}
.mat-title-section {
   margin-top: -0.5rem;
   margin-bottom: -0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/annotation-controller/download-list/download-list.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;AACjB;AACA;GACG,mBAAmB;GACnB,sBAAsB;AACzB","sourcesContent":[".header-section, .body-section {\n   margin: 12px 0;\n}\n.mat-title-section {\n   margin-top: -0.5rem;\n   margin-bottom: -0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
